import { Link } from "react-router-dom";

import { DEFAULT_CASE_ID } from "../lib/cases";

export function NotFoundRoute() {
  return (
    <div className="mx-auto max-w-xl px-6 py-16 text-center">
      <p className="font-editorial text-xl text-ink">This page doesn't exist.</p>
      <Link
        to={`/cases/${DEFAULT_CASE_ID}`}
        className="mt-6 inline-block rounded border border-rule-strong px-4 py-2 text-sm text-ink hover:bg-surface"
      >
        Go to the case overview
      </Link>
    </div>
  );
}
